export * from "./portal.component";
